import React, { useEffect } from "react";
import { connect } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import { CircleAlert } from "lucide-react";
import ApprovalCard from "./ApprovalCard";
import {
	getPendingApproval
} from "../../../../redux/overview/overviewState";

const PendingApprovalsTable = ({
  recordList,
  getList
}) => {

  useEffect(() => {
    getList();
  }, [getList]);
  return (
    <HeaderComponent
      title="Pending Approvals"
      description="Leave and overtime requests awaiting approval"
      bgcolor="bg-orange-50/30"
      icon={<CircleAlert size={20} />}
      colorTheme="flat-orange"
      border="border-b"
      rightNav={
        <span className="inline-flex items-center justify-center rounded-xl border font-medium shrink-0 gap-1 bg-orange-100 text-orange-700 border-orange-300 text-[9px] px-2 py-0.5 h-5">
          {`⚡ ${recordList?.data?.length || 0}`}
        </span>
      }
    >
      <div className="pt-5 flex-1">
        <div className="relative pr-1 h-[500px] overflow-y-auto">
          <div className="space-y-3">
            {recordList?.data?.map((item) => (
              <ApprovalCard 
                key={`${item.type}_${item.id}`} 
                recordData={item} 
              />
            ))}
          </div>
        </div>
      </div>
    </HeaderComponent>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.overview.teamPendingApproval?.data,
});

const mapDispatchToProps = (dispatch) => ({
  getList: (filters) => dispatch(getPendingApproval(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PendingApprovalsTable);
